/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Badge } from '@nexigendigital/nxui'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    domain: string,
    tld: string,
    premium: boolean
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function DomainWithExtension({ domain, tld, premium }: Props) {
    return (
        <Premium>
            <DomainName>
                <span>
                    {domain}
                </span>
                <TLD>
                    {tld}
                </TLD>
            </DomainName>
            {premium ? <Badge color={'primary'}>Premium</Badge> : null}
        </Premium>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const DomainName = styled.p`
    word-break: break-word;
`

const Premium = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`

const TLD = styled.span`
    color: ${props => props.theme['black--100']};
`
